module.exports = __webpack_public_path__ + "static/media/asurion-hero-desktop.3b6d43bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/asurion-hero-desktop.jpg
// module id = 1382
// module chunks = 0